export default function SocialHandle({ media }) {
    const { link, fa, title } = media;
    return (
      <div className="col text-center">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-social"
        >
          <i className={fa} title={title} style={{ fontSize: 50 }}></i>
          <div><b>{title}</b></div>
        </a>
      </div>
    );
  }